import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeURL' })
export class SafeURLPipe implements PipeTransform {
  /**
   * Sanitization is the inspection of an untrusted value,
   * turning it into a value that's safe to insert into the DOM.
   * In many cases, sanitization doesn't change a value at all.
   */
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string | null) {
    if (url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    return null;
  }
}

@Pipe({ name: 'safeHTML' })
export class SafeHTMLPipe implements PipeTransform {
  /**
   * Sanitization is the inspection of an untrusted value,
   * turning it into a value that's safe to insert into the DOM.
   * In many cases, sanitization doesn't change a value at all.
   */
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string | null) {
    if (html) {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    return null;
  }
}
